import { SIGN_UP_REQUEST } from "../actions/utilities";

const INITIAL_STATE = {
    checkUserAccountLoading: false,
    checkUserAccountSuccess: false,
    checkUserAccountFailure: false,
    checkUserAccountError: null,
    checkUserAccount: null,

    resendNewOtpLoading: false,
    resendNewOtpSuccess: false,
    resendNewOtpFailure: false,
    resendNewOtpError: null,
    resendNewOtp: null,

    confirmOTPLoading: false,
    confirmOTPSuccess: false,
    confirmOTPFailure: false,
    confirmOTPError: null,
    confirmOTP: null,

    completeUserProfileLoading: false,
    completeUserProfileSuccess: false,
    completeUserProfileFailure: false,
    completeUserProfileError: null,
    completeUserProfile: null,

    signUpProfileLoading: false,
    signUpProfileSuccess: false,
    signUpProfileFailure: false,
    signUpProfileError: null,
    signUpProfile: null,
}

export const singUpUser = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SIGN_UP_REQUEST.CHECK_EXIST_ACCOUTN_REQUEST:
            return {
                ...state,
                checkUserAccountLoading: true,
                checkUserAccountSuccess: false,
                checkUserAccountFailure: false,
                checkUserAccountError: null,
            }
        case SIGN_UP_REQUEST.CHECK_EXIST_ACCOUTN_SUCCESS:
            return {
                ...state,
                checkUserAccountLoading: false,
                checkUserAccountSuccess: true,
                checkUserAccountFailure: false,
                checkUserAccountError: null,
                checkUserAccount: action.payload
            }
        case SIGN_UP_REQUEST.CHECK_EXIST_ACCOUTN_FAILURE:
            return {
                ...state,
                checkUserAccountLoading: false,
                checkUserAccountSuccess: false,
                checkUserAccountFailure: true,
                checkUserAccountError: action.payload,
            }

        case SIGN_UP_REQUEST.RESEND_OTP_REQUEST:
            return {
                ...state,
                resendNewOtpLoading: true,
                resendNewOtpSuccess: false,
                resendNewOtpFailure: false,
                resendNewOtpError: null,
            }
        case SIGN_UP_REQUEST.RESEND_OTP_SUCCESS:
            return {
                ...state,
                resendNewOtpLoading: false,
                resendNewOtpSuccess: true,
                resendNewOtpFailure: false,
                resendNewOtpError: null,
                resendNewOtp: action.payload
            }
        case SIGN_UP_REQUEST.RESEND_OTP_FAILURE:
            return {
                ...state,
                resendNewOtpLoading: false,
                resendNewOtpSuccess: false,
                resendNewOtpFailure: true,
                resendNewOtpError: action.payload,
            }

        case SIGN_UP_REQUEST.CONFIRM_OTP_REQUEST:
            return {
                ...state,
                confirmOTPLoading: true,
                confirmOTPSuccess: false,
                confirmOTPFailure: false,
                confirmOTPError: null,
            }
        case SIGN_UP_REQUEST.CONFIRM_OTP_SUCCESS:
            return {
                ...state,
                confirmOTPLoading: false,
                confirmOTPSuccess: true,
                confirmOTPFailure: false,
                confirmOTPError: null,
                confirmOTP: action.payload
            }
        case SIGN_UP_REQUEST.CONFIRM_OTP_FAILURE:
            return {
                ...state,
                confirmOTPLoading: false,
                confirmOTPSuccess: false,
                confirmOTPFailure: true,
                confirmOTPError: action.payload,
            }

        case SIGN_UP_REQUEST.COMPLETE_PROFILE_REQUEST:
            return {
                ...state,
                completeUserProfileLoading: true,
                completeUserProfileSuccess: false,
                completeUserProfileFailure: false,
                completeUserProfileError: null,
            }
        case SIGN_UP_REQUEST.COMPLETE_PROFILE_SUCCESS:
            return {
                ...state,
                completeUserProfileLoading: false,
                completeUserProfileSuccess: true,
                completeUserProfileFailure: false,
                completeUserProfileError: null,
                completeUserProfile: action.payload
            }
        case SIGN_UP_REQUEST.COMPLETE_PROFILE_FAILURE:
            return {
                ...state,
                completeUserProfileLoading: false,
                completeUserProfileSuccess: false,
                completeUserProfileFailure: true,
                completeUserProfileError: action.payload,
            }


        case SIGN_UP_REQUEST.SIGN_UP_PROFILE_REQUEST:
            return {
                ...state,
                signUpProfileLoading: true,
                signUpProfileSuccess: false,
                signUpProfileFailure: false,
                signUpProfileError: null,
            }
        case SIGN_UP_REQUEST.SIGN_UP_PROFILE_SUCCESS:
            return {
                ...state,
                signUpProfileLoading: false,
                signUpProfileSuccess: true,
                signUpProfileFailure: false,
                signUpProfileError: null,
                signUpProfile: action.payload
            }
        case SIGN_UP_REQUEST.SIGN_UP_PROFILE_FAILURE:
            return {
                ...state,
                signUpProfileLoading: false,
                signUpProfileSuccess: false,
                signUpProfileFailure: true,
                signUpProfileError: action.payload,
            }
        default:
            return state;
    }
}